import ReauthenticateCode from './ReauthenticateCode'
import NavBaseTemplate from "../../components/templates/NavBaseTemplate";

export default function ReauthenticateTOTP(props) {
    return (
        <>
            <ReauthenticateCode>
                <p>Please enter an authenticator code:</p>
            </ReauthenticateCode>
        </>
    )
}
